export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/neighborhood.7ac5e2f.svg";